/**
 * シミュレーションの挙動バージョン。
 *
 * `step()` の計算順序や調整値を変えると、過去のリプレイが再生できなくなる。
 * ランキングを公開した瞬間から、これは後方互換性の問題になる。
 *
 * 運用の約束:
 *  - **挙動が変わる変更を入れたら必ず上げる。** 見た目や音だけの変更では上げない。
 *  - リプレイとランキングの行の両方に記録する。
 *  - サーバーはバージョンごとの検証器を持つ。古い記録は再検証せず、そのまま保持する。
 *  - **ランキングはバージョンで区切る。** シーズンの切り替えと揃えると自然。
 *
 * 履歴:
 *  1 — Phase 0。波・ダイブ・宝・離岸流のみ。
 *  2 — 生き物（クラゲ・イルカ・子ガメ）と干潮を追加。
 */
export const SIM_VERSION = 2;
